import React from 'react';
import { useTheme } from 'styled-components';
import getIsMobile from '../atoms/utils/getIsMobile';

const isMobile = getIsMobile();


export const ListGridSvg = (props) => {

  const { selected, onClick, width, height, color } = props;
  const theme = useTheme();

  if (selected) {
    return (
      <svg onClick={onClick} width={width ?? "18"} height={height ?? "17"} fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.0439453" width="5.14847" height="5.03165" rx="1.33285" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="5.94336" width="5.14847" height="5.03165" rx="1.33285" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="12.0439" width="5.14847" height="5.03165" rx="1.33285" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="5.94336" y="6.01562" width="5.14847" height="5.03165" rx="1.33285" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="12.0439" y="6.01562" width="5.14847" height="5.03165" rx="1.33285" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="0.0439453" y="6.01562" width="5.14847" height="5.03165" rx="1.33285" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="0.0439453" y="11.9688" width="5.14847" height="5.03165" rx="1.33285" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="5.94336" y="11.9688" width="5.14847" height="5.03165" rx="1.33285" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="12.0439" y="11.9688" width="5.14847" height="5.03165" rx="1.33285" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
      </svg>
    )
  } else {
    if (isMobile) {
      return (
        <svg onClick={onClick} width={width ?? "18"} height={height ?? "17"} fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.0439453" width="5.14847" height="5.03165" rx="1.33285" fill="#C2CCCE" />
          <rect x="5.94336" width="5.14847" height="5.03165" rx="1.33285" fill="#C2CCCE" />
          <rect x="12.0439" width="5.14847" height="5.03165" rx="1.33285" fill="#C2CCCE" />
          <rect x="5.94336" y="6.01562" width="5.14847" height="5.03165" rx="1.33285" fill="#C2CCCE" />
          <rect x="12.0439" y="6.01562" width="5.14847" height="5.03165" rx="1.33285" fill="#C2CCCE" />
          <rect x="0.0439453" y="6.01562" width="5.14847" height="5.03165" rx="1.33285" fill="#C2CCCE" />
          <rect x="0.0439453" y="11.9688" width="5.14847" height="5.03165" rx="1.33285" fill="#C2CCCE" />
          <rect x="5.94336" y="11.9688" width="5.14847" height="5.03165" rx="1.33285" fill="#C2CCCE" />
          <rect x="12.0439" y="11.9688" width="5.14847" height="5.03165" rx="1.33285" fill="#C2CCCE" />
        </svg>
      )
    }

    return (
      <svg onClick={onClick} width={width ?? "18"} height={height ?? "17"} fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.0439453" width="5.14847" height="5.03165" rx="1.33285" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.5" />
        <rect x="5.94336" width="5.14847" height="5.03165" rx="1.33285" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.5" />
        <rect x="12.0439" width="5.14847" height="5.03165" rx="1.33285" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.5" />
        <rect x="5.94336" y="6.01562" width="5.14847" height="5.03165" rx="1.33285" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.5" />
        <rect x="12.0439" y="6.01562" width="5.14847" height="5.03165" rx="1.33285" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.5" />
        <rect x="0.0439453" y="6.01562" width="5.14847" height="5.03165" rx="1.33285" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.5" />
        <rect x="0.0439453" y="11.9688" width="5.14847" height="5.03165" rx="1.33285" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.5" />
        <rect x="5.94336" y="11.9688" width="5.14847" height="5.03165" rx="1.33285" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.5" />
        <rect x="12.0439" y="11.9688" width="5.14847" height="5.03165" rx="1.33285" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.5" />
      </svg>
    )
  }
}